module.exports = __webpack_public_path__ + "img/vimeo_black.2b868c7c.png";